import React from 'react';

import { Field } from 'formik';
import PropTypes from 'prop-types';
import { Form as SemanticForm } from 'semantic-ui-react';
import { InputFormField } from '@playbookux/playbook-web-core';

import { withTranslation } from '../../../core/i18n';
import { firstScreen } from '../card-sort/constants';
import TestTypes from '../../../core/constants/testTypes';
import { NDA_URL } from './constants';

import InputTreeTest from './input-tree-test';

import {
  Segment,
  Text,
  FieldContainer,
  InputContainer,
  Button,
  NDA,
} from './styles';

import RecruitParticipantInstructions from '../../../core/components/recruit-participant-instructions';

const FormComputer = ({
  onClick,
  status,
  project,
  phrases,
  collectTesterName = true,
}) => {
  const { testType } = project;

  const isTreeTest = testType === TestTypes.TREE_TEST;

  const displayFirstScreenMessage = (testType === TestTypes.CARD_SORT || testType === TestTypes.SURVEY || isTreeTest);

  return (
    <Segment isPadding={isTreeTest}>
      <>
        {(displayFirstScreenMessage && collectTesterName) && (
          <Text.Bold>{firstScreen}</Text.Bold>
        )}

        {(!displayFirstScreenMessage && (testType === TestTypes.UNMODERATED || collectTesterName)) && (
          <RecruitParticipantInstructions instructions={phrases.launch_instructions} />
        )}

        {(isTreeTest && collectTesterName) && (
          <SemanticForm as="div">
            <InputTreeTest />
          </SemanticForm>
        )}

        {(!isTreeTest && collectTesterName) && (
          <SemanticForm as="div">
            <FieldContainer>
              <Text>
                {phrases.first_name}
              </Text>

              <InputContainer>
                <Field
                  component={InputFormField}
                  name="firstName"
                  placeholder={phrases.first_name}
                  aria-required="true"
                  aria-label="First name"
                />
              </InputContainer>
              <Text>
                {phrases.last_name}
              </Text>

              <InputContainer>
                <Field
                  component={InputFormField}
                  name="lastName"
                  placeholder={phrases.last_name}
                  aria-required="true"
                  aria-label="Last name"
                />
              </InputContainer>
            </FieldContainer>
          </SemanticForm>
        )}

        <Button
          data-tester-test-proceed
          onClick={onClick}
          type="submit"
          loading={status && status.isLoading}
          disabled={status && status.isLoading}
          aria-label="Next"
        >
          {phrases.proceed_to_study_button}
        </Button>

        <NDA>
          By clicking &quot;Proceed to study&quot; you agree to the
          {' '}
          <a href={NDA_URL} target="_blank" rel="noopener noreferrer">terms of this NDA</a>
        </NDA>

      </>
    </Segment>
  );
};

FormComputer.propTypes = {
  status: PropTypes.shape({
    isLoading: PropTypes.bool,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  project: PropTypes.shape({
    recorderType: PropTypes.string.isRequired,
    testType: PropTypes.string.isRequired,
  }).isRequired,
  phrases: PropTypes.shape({
    card_sort_launch_instructions: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    launch_instructions: PropTypes.string,
    proceed_to_study_button: PropTypes.string,
  }).isRequired,
  collectTesterName: PropTypes.bool.isRequired,
};

export default withTranslation(FormComputer);
